export type WelcomeDelivery2Props = {
  onContinue?: () => void;
};

export type WelcomeDelivery2ScreenModel = {
  onContinue?: () => void;
};

export function createWelcomeDelivery2ScreenModel(
  props: WelcomeDelivery2Props,
): WelcomeDelivery2ScreenModel {
  return {
    onContinue: props.onContinue,
  };
}
